import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authExchange } from "@/lib/api";
import { useRef } from "react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    authExchange(session_id)
      .then((user) => {
        window.history.replaceState(null, "", "/admin");
        if (user.is_admin) {
          navigate("/admin", { replace: true, state: { user } });
        } else {
          navigate("/admin/login?error=not_admin", { replace: true });
        }
      })
      .catch(() => {
        navigate("/admin/login?error=auth_failed", { replace: true });
      });
  }, [navigate]);

  return (
    <div data-testid="auth-callback-page" className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 rounded-full border-2 border-[#FE7200] border-t-transparent animate-spin" />
        <div className="mt-4 text-sm text-zinc-300">Signing you in…</div>
      </div>
    </div>
  );
}
